'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require('react-redux');

var _project = require('redux/modules/project');

var projectActions = _interopRequireWildcard(_project);

var _contacts = require('redux/modules/contacts');

var contactsActions = _interopRequireWildcard(_contacts);

var _reduxConnect = require('redux-connect');

var _reactI18next = require('react-i18next');

var _components = require('components');

var _Link = require('react-router/lib/Link');

var _Link2 = _interopRequireDefault(_Link);

var _auth = require('selectors/auth');

var _projects = require('helpers/projects');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _reactRouterRedux = require('react-router-redux');

var _asyncPromise = require('helpers/async-promise');

var _asyncPromise2 = _interopRequireDefault(_asyncPromise);

var _ImportRecipientsCSVButton = require('components/ImportRecipientsCSVButton/ImportRecipientsCSVButton');

var _ImportRecipientsCSVButton2 = _interopRequireDefault(_ImportRecipientsCSVButton);

var _AddRecipientRow = require('components/Recipients/AddRecipientRow/AddRecipientRow');

var _AddRecipientRow2 = _interopRequireDefault(_AddRecipientRow);

var _ProjectRecipientsList = require('components/Recipients/ProjectRecipientsList/ProjectRecipientsList');

var _ProjectRecipientsList2 = _interopRequireDefault(_ProjectRecipientsList);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./ProjectRecipients.scss');

var ProjectRecipients = (_dec = (0, _reduxConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState,
        projectId = _ref.params.projectId;
    var isLoadProjectTime = projectActions.isLoadProjectTime,
        loadProject = projectActions.loadProject,
        initProject = projectActions.initProject;
    var loadGroups = contactsActions.loadGroups;

    var id = Number(projectId);
    var promises = [dispatch(projectActions.loadRecipientsList(projectId)).promise];

    if (id) {
      if (isLoadProjectTime(id, getState())) {
        promises.push(dispatch(loadProject(id)).promise, dispatch(loadGroups(id)).promise);
      }
    } else {
      promises.push(dispatch(initProject()));
    }

    return (0, _asyncPromise2.default)(_promise2.default.all(promises));
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state, ownProps) {
  return {
    addRecipientsFromGroupsLoading: state.project.addRecipientsFromGroupsLoading,
    permissions: (0, _auth.getPermissions)(state),
    project: state.project.projectData,
    projectId: Number(ownProps.params.projectId),
    projectLoading: state.project.projectLoading,
    projectType: ownProps.params.type,
    sendEmailLoading: state.project.sendEmailLoading
  };
}, (0, _extends3.default)({}, projectActions, { pushState: _reactRouterRedux.push }), null, { withRef: true }), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(ProjectRecipients, _Component);

  function ProjectRecipients() {
    var _ref2;

    (0, _classCallCheck3.default)(this, ProjectRecipients);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = ProjectRecipients.__proto__ || (0, _getPrototypeOf2.default)(ProjectRecipients)).call.apply(_ref2, [this].concat(args)));

    _this.state = { sendType: 'new' };
    return _this;
  }

  (0, _createClass3.default)(ProjectRecipients, [{
    key: 'onImportRecipients',
    value: function onImportRecipients(_ref3) {
      var data = _ref3.data;
      var _props = this.props,
          addRecipients = _props.addRecipients,
          projectId = _props.projectId;

      addRecipients(projectId, data);
    }
  }, {
    key: 'setSendType',
    value: function setSendType(sendType) {
      this.setState({ sendType: sendType });
    }
  }, {
    key: '_onSelectContacts',
    value: function _onSelectContacts(contacts) {
      var _props2 = this.props,
          projectId = _props2.projectId,
          addRecipientsFromContacts = _props2.addRecipientsFromContacts,
          loadRecipientsList = _props2.loadRecipientsList;

      this.selectContactsModalEl.close();
      addRecipientsFromContacts(projectId, contacts).promise.then(function () {
        return loadRecipientsList(projectId).promise;
      });
    }
  }, {
    key: '_onSelectGroups',
    value: function _onSelectGroups(groups) {
      var _props3 = this.props,
          projectId = _props3.projectId,
          addRecipientsFromGroups = _props3.addRecipientsFromGroups,
          loadRecipientsList = _props3.loadRecipientsList;

      this.selectGroupsModalEl.close();
      addRecipientsFromGroups(projectId, groups).promise.then(function () {
        return loadRecipientsList(projectId).promise;
      });
    }
  }, {
    key: '_onAddGroup',
    value: function _onAddGroup() {
      var _props4 = this.props,
          projectId = _props4.projectId,
          loadRecipientsList = _props4.loadRecipientsList;

      loadRecipientsList(projectId);
    }
  }, {
    key: 'sendEmail',
    value: function sendEmail(sendType) {
      var _props5 = this.props,
          projectId = _props5.projectId,
          sendEmail = _props5.sendEmail;

      sendEmail(projectId, sendType);
    }
  }, {
    key: 'next',
    value: function next() {
      var _props6 = this.props,
          projectType = _props6.projectType,
          projectId = _props6.projectId,
          sendEmail = _props6.sendEmail,
          pushState = _props6.pushState;
      var sendType = this.state.sendType;

      sendEmail(projectId, sendType).promise.then(function () {
        return pushState('/projects/' + projectType + '/' + projectId + '/confirmation');
      });
    }
  }, {
    key: 'renderSendTypeRadios',
    value: function renderSendTypeRadios() {
      var t = this.props.t;


      return _react2.default.createElement(
        'div',
        { className: styles.remindersRadios },
        this.renderSendTypeRadio({
          type: 'new',
          text: t('New recipients only')
        }),
        this.renderSendTypeRadio({
          type: 'remind',
          text: t('Send reminders')
        }),
        this.renderSendTypeRadio({
          type: 'all',
          text: t('Send to all recipients')
        }),
        _react2.default.createElement(
          'div',
          { className: styles.reminderHint },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'span',
              { className: 'bold margin-right-5' },
              t('NEW Recipients Only'),
              ':'
            ),
            _react2.default.createElement(_reactI18next.Interpolate, {
              i18nKey: 'only sends to those marked as {{keyword}} in the recipient list',
              keyword: _react2.default.createElement(
                'span',
                { className: 'bold' },
                t('NEW')
              )
            })
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'span',
              { className: 'bold margin-right-5' },
              t('Send REMINDERS'),
              ':'
            ),
            _react2.default.createElement(_reactI18next.Interpolate, {
              i18nKey: 'only sends to those who have previously received the email but have {{keyword}} yet listened',
              keyword: _react2.default.createElement(
                'span',
                { className: 'bold' },
                t('NOT')
              )
            })
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'span',
              { className: 'bold margin-right-5' },
              t('Send to ALL recipients'),
              ':'
            ),
            _react2.default.createElement(_reactI18next.Interpolate, {
              i18nKey: 'sends to {{keyword}} in the recipient list regardless',
              keyword: _react2.default.createElement(
                'span',
                { className: 'bold' },
                t('EVERYONE')
              )
            })
          )
        )
      );
    }
  }, {
    key: 'renderSendTypeRadio',
    value: function renderSendTypeRadio(_ref4) {
      var _this2 = this;

      var type = _ref4.type,
          text = _ref4.text;
      var sendType = this.state.sendType;


      return _react2.default.createElement(_components.Checkbox, {
        radio: true,
        small: true,
        checked: sendType === type,
        onChange: function onChange() {
          return _this2.setSendType(type);
        },
        className: styles.reminderRadio,
        textAfter: _react2.default.createElement(
          'span',
          { className: styles.reminderText },
          text
        )
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props7 = this.props,
          t = _props7.t,
          projectId = _props7.projectId,
          projectType = _props7.projectType,
          projectLoading = _props7.projectLoading,
          permissions = _props7.permissions,
          sendEmailLoading = _props7.sendEmailLoading,
          addRecipientsFromGroupsLoading = _props7.addRecipientsFromGroupsLoading;

      var project = this.props.project || {};
      var isNewProject = project.status === 'Created';
      var importUploaderParams = {
        queryParams: { projectId: projectId },
        endpoint: '/api/contacts_wa/addRecipientsCSV'
      };

      return _react2.default.createElement(
        'div',
        { className: 'page pos-rel' },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Project' }),
        _react2.default.createElement(
          'div',
          { className: 'container-fluid' },
          _react2.default.createElement(
            'h1',
            null,
            t('Recipients'),
            projectLoading && _react2.default.createElement(_components.Loader, { small: true, inline: true, right: true })
          ),
          _react2.default.createElement(_components.ProjectBreadcrumbs, { projectId: projectId, projectType: projectType }),
          _react2.default.createElement(
            'div',
            { className: 'section' },
            _react2.default.createElement(
              'h3',
              null,
              t('Cover picture')
            ),
            _react2.default.createElement(_components.ProjectCover, { project: project, disabled: projectLoading || !permissions.editProjectCover })
          ),
          projectType !== _projects.projectTypes.video && project.imageThumb && permissions.editProjectCover && _react2.default.createElement(
            'div',
            { className: 'section' },
            _react2.default.createElement(
              'h3',
              null,
              t('Choose the packshot style')
            ),
            _react2.default.createElement(_components.CoverStyle, null)
          ),
          _react2.default.createElement(
            'div',
            { className: 'section' },
            _react2.default.createElement(
              'h3',
              null,
              t('Recipients management')
            ),
            _react2.default.createElement(
              'h5',
              null,
              t('Option'),
              ' 1'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.addOption },
              _react2.default.createElement(
                'div',
                { className: 'hint small' },
                t('Import recipients from csv file. Take me there.')
              ),
              _react2.default.createElement(
                'div',
                { className: styles.csvHint },
                _react2.default.createElement(_components.CsvHint, { className: 'margin-left-10' })
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_ImportRecipientsCSVButton2.default, {
                  uploaderParams: importUploaderParams,
                  onImport: this.onImportRecipients
                })
              )
            ),
            _react2.default.createElement(
              'h5',
              null,
              t('Option'),
              ' 2'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.addOption },
              _react2.default.createElement(
                'div',
                { className: 'hint small' },
                t('Import groups of contacts')
              ),
              _react2.default.createElement(
                'div',
                null,
                addRecipientsFromGroupsLoading ? _react2.default.createElement(_components.Loader, null) : _react2.default.createElement(
                  'button',
                  { type: 'button', className: 'btn btn-primary', onClick: function onClick() {
                      return _this3.selectGroupsModalEl.open();
                    } },
                  t('Import')
                )
              )
            ),
            _react2.default.createElement(
              'h5',
              null,
              t('Option'),
              ' 3'
            ),
            _react2.default.createElement(
              'div',
              { className: 'padding-left-10' },
              _react2.default.createElement(_AddRecipientRow2.default, {
                projectId: projectId,
                onAddGroup: this._onAddGroup,
                hintClassName: 'hint small'
              })
            ),
            _react2.default.createElement(
              _components.Modal,
              { ref: function ref(el) {
                  return _this3.selectContactsModalEl = el;
                }, title: t('Select recipients from contacts'), backdrop: 'static', bsSize: 'lg' },
              _react2.default.createElement(_components.SelectContactsList, { onSelect: this._onSelectContacts })
            ),
            _react2.default.createElement(
              _components.Modal,
              { ref: function ref(el) {
                  return _this3.selectGroupsModalEl = el;
                }, title: t('Select recipients from groups'), backdrop: 'static', bsSize: 'lg' },
              _react2.default.createElement(_components.SelectGroupsList, { onSelect: this._onSelectGroups })
            ),
            _react2.default.createElement(
              'h5',
              { className: 'margin-top-20' },
              t('List of recipients')
            ),
            _react2.default.createElement(_ProjectRecipientsList2.default, {
              projectId: projectId,
              individualExpiryDate: !!project.individualExpiryDate,
              downloadAuthorised: !!project.downloadAuthorised,
              className: 'fullWidthSm'
            }),
            !isNewProject && this.renderSendTypeRadios()
          ),
          _react2.default.createElement(
            'div',
            { className: 'section' },
            _react2.default.createElement(
              'h3',
              null,
              t('Links')
            ),
            _react2.default.createElement(_components.RecipientsLinksForm, { projectId: projectId })
          ),
          _react2.default.createElement(
            'div',
            { className: 'section' },
            _react2.default.createElement(
              'h3',
              null,
              t('Email')
            ),
            _react2.default.createElement(_components.RecipientsEmailWysiwyg, { projectId: projectId })
          ),
          _react2.default.createElement(
            'div',
            { className: 'margin-top-30 text-right' },
            _react2.default.createElement(
              _Link2.default,
              { to: '/projects/' + projectType + '/' + projectId + '/materials', className: 'btn btn-accent wide margin-vert-5' },
              t('Back')
            ),
            _react2.default.createElement(
              _components.Button,
              {
                type: 'button',
                className: 'btn-primary wide margin-left-20 margin-vert-5',
                onClick: this.next,
                loading: sendEmailLoading
              },
              t('Next')
            )
          )
        )
      );
    }
  }]);
  return ProjectRecipients;
}(_react.Component), _class3.propTypes = {
  addRecipients: _propTypes2.default.func,
  addRecipientsFromContacts: _propTypes2.default.func,
  addRecipientsFromGroups: _propTypes2.default.func,
  addRecipientsFromGroupsLoading: _propTypes2.default.bool,
  loadRecipientsList: _propTypes2.default.func,
  permissions: _propTypes2.default.object,
  project: _propTypes2.default.object,
  projectId: _propTypes2.default.number,
  projectLoading: _propTypes2.default.bool,
  projectType: _propTypes2.default.string,
  pushState: _propTypes2.default.func,
  sendEmail: _propTypes2.default.func,
  sendEmailLoading: _propTypes2.default.bool,
  t: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onImportRecipients', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onImportRecipients'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, '_onSelectContacts', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, '_onSelectContacts'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, '_onSelectGroups', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, '_onSelectGroups'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, '_onAddGroup', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, '_onAddGroup'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'next', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'next'), _class2.prototype)), _class2)) || _class) || _class) || _class);
exports.default = ProjectRecipients;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Project/ProjectRecipients/ProjectRecipients.js
// module id = 2197
// module chunks = 1